module.exports = __webpack_public_path__ + "img/rdw-2.6d6b702d.jpg";